import { BindedView } from 'marionette.binding';
import AttachmentView from 'base/views/attachments';

const JoinosComposeView = BindedView.extend({
  template: require('messaging/templates/joinos.html'),

  ui: {
    text: '.textfield.text',
    title: '.textfield.title'
  },
  
  bindings: {
    'value @ui.text': 'text',
    'value @ui.title': 'title'
  },
  
  regions: {
    attachments: '.attachment-hook'
  },

  onRender() {
    BindedView.prototype.onRender.call(this);

    this.showChildView('attachments', new AttachmentView({
      collection: this.model.get('documents')
    }));
  }
});

export default JoinosComposeView;



// WEBPACK FOOTER //
// ./messaging/views/joinos.js